const integrationRoutes = [
  {
    path: "/integrations/melhor-envio",
    name: "integrations.melhor-envio.settings",
    component: () =>
      import("@/modules/integration/views/MelhorEnvioSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Melhor Envio — Configurações",
      roles: [5]
    }
  }
];

export default integrationRoutes;
